import React, { useState, useEffect, createContext, useContext } from 'react';
import { useSelector } from 'react-redux';
import { DASHBOARD_ROUTES, excludeRoutes } from '../../config/routes';
import { useLocation } from "react-router-dom";

const RouteContext = createContext();

function findActiveTab(routes, path) {

    const activeTab = routes.find((r) => {
        return path.includes(r.path);
    });

    if (activeTab) return activeTab.id;
    return null;
};

export function DashboardRouteProvider(props) {

    const [activeTab, setActiveTab] = useState(null);
    let location = useLocation();

    const excluded = useSelector((state: RootState) => state.mission.activeConfig?.layout?.["dashboard"]?.["exclude"] || []);

    const routes = excludeRoutes(excluded, DASHBOARD_ROUTES);

    useEffect(() => {
        const active = findActiveTab(routes, location.pathname);
        setActiveTab(active);
    }, [location.pathname]);

    return (
        <RouteContext.Provider value={{ activeTab, routes }}>
            {props.children}
        </RouteContext.Provider>
    );
};

export const useRoute = () => useContext(RouteContext);